// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@charset \"UTF-8\";\n/* 任务编辑弹窗 teleport 到 body，需全局样式：内容超高时弹窗内部滚动 */\n.task-dialog .el-dialog__body {\n  max-height: calc(100vh - 5.86667rem);\n  overflow-y: auto;\n  padding-top: 0.32rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
